import { render } from "./FormFilterTagsWithButtonComponent.vue?vue&type=template&id=a12d9b92&scoped=true"
import script from "./FormFilterTagsWithButtonComponent.vue?vue&type=script&lang=js"
export * from "./FormFilterTagsWithButtonComponent.vue?vue&type=script&lang=js"

import "./FormFilterTagsWithButtonComponent.vue?vue&type=style&index=0&id=a12d9b92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a12d9b92"]])

export default __exports__